import { default as roomReservation } from './room-reservation/routes'
import { default as scheduleActivity } from './schedule-activity/routes'
import { default as travelTime } from './travel-time/routes'

export default [
    ...roomReservation,
    ...scheduleActivity,
    ...travelTime,
]